import { render, staticRenderFns } from "./SimpleContextMenu.vue?vue&type=template&id=1b13d316&"
import script from "./SimpleContextMenu.vue?vue&type=script&lang=ts&"
export * from "./SimpleContextMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b13d316')) {
      api.createRecord('1b13d316', component.options)
    } else {
      api.reload('1b13d316', component.options)
    }
    module.hot.accept("./SimpleContextMenu.vue?vue&type=template&id=1b13d316&", function () {
      api.rerender('1b13d316', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/src/overlays/SimpleContextMenu.vue"
export default component.exports